import { create } from 'zustand';

interface PrinterSettingModalStore {
  printerFilter: string;
  setPrinterFilter: (filter: string) => void;
}

export const usePrinterSettingModalStore = create<PrinterSettingModalStore>((set) => ({
  printerFilter: '',
  setPrinterFilter: (filter) => set({ printerFilter: filter }),
}));
